import { useEffect, useState } from "react";
import { Card, Button, Row, Col, Container } from "react-bootstrap";
import { PDFInputFile } from "../../../../components/PDFFileHandler";
import SearchFilter from "../../../../components/SearchFilter";
import Table from "../../../../components/Table";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import ConfirmModal from "../../../../components/ConfirmModal";

export default function ReportTab() {
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({ Array: [] });
  const searchInput = [
    {
      name: "BP_master_code",
      label: "รหัสลูกค้าหลัก ( BP Master Code )",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 4
    },
    {
      name: "Cus_name",
      label: "ชื่อลูกค้า",
      type: "text",
      size: 8,
      classNames: { col: "mb-3", label: "mb-1" },
      disabled: true
    },
    {
      name: "Cus_code ",
      label: "รหัสลูกค้า (BP code)",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 4
    },
    {
      name: "Customer_code ",
      label: "รหัสสาขา (ลูกค้า)",
      size: 2,
      type: "text",
      classNames: { col: "mb-3", label: "mb-1" },
      disabled: true
    },
    {
      name: "Branch_name",
      label: "ชื่อลูกค้า/สาขา",
      type: "text",
      size: 6,
      classNames: { col: "mb-3", label: "mb-1" },
      disabled: true
    },
    {
      name: "Pm_of_month  ",
      label: "เดือน",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 2
    },
    {
      name: "Pm_of_year  ",
      label: "ปี",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 2
    },
    {
      name: "Radio_all",
      label: "ทั้งหมด",
      type: "radio",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 1
    },
    {
      name: "Radio_number",
      label: "เลขที่ใบสั่งงาน",
      type: "radio",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 2
    },
    {
      name: "work_order_number",
      label: "เลขที่ใบสั่งงาน",
      type: "text",
      disabled: true,
      classNames: { col: "mb-3", label: "mb-1" },
      size: 2
    },
    {
      name: "team_name_leader",
      label: "ชื่อทีม/หัวหน้า",
      type: "text",
      disabled: true,
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "Item_code",
      label: "รหัสสินค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 4
    },
    {
      name: "Item_name",
      label: "รายละเอียดสินค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 5
    }
  ];
  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 pb-1 bg-transparent border-bottom-0">
          <Card.Title className="fs-2 text-center">
            ค้นหาใบสั่งงาน Service Request
          </Card.Title>
        </Card.Header>

        <SearchFilter
          data={data.Array}
          inputField={searchInput}
          fieldClassName={{
            inputRow: "justify-content-start",
            actionButton: "w-auto mb-1 py-2"
          }}
          searchCallback={(search) =>
            setSearchValue((prev) => ({
              ...prev,
              Array: search
            }))
          }
        />
      </Card>
    </>
  );
}
